import React, { FC, useState } from 'react';
import { isEmpty } from 'lodash';

import { Layout } from '../../components/Layout';
import { PhoneInput } from '../../components/PhoneInput';
import { ButtonWithLoading } from '../global/ButtonWithLoading';
import { getIsAuthenticated, signIn } from './authStore';
import { useDispatchWithHistory } from '../actionWithHistory';
import { Link } from '../navigation/router';
import { signUpStartRoute } from '../../config/signupConfig';
import { phoneNumberMaxLength } from '../../config/appConfig';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routes } from '../../domain/routes';
import { useTranslation } from 'react-i18next';

export const SignInPage: FC = () => {
  const dispatch = useDispatchWithHistory();
  const [phoneNumber, setPhoneNumber] = useState('');

  const canSignIn = !isEmpty(phoneNumber);
  const handleSignIn = () => {
    dispatch(signIn, { phone: phoneNumber });
  };
  const isAuth = useSelector(getIsAuthenticated);
  const { t } = useTranslation('translation', { keyPrefix: 'signIn.index' });

  if (isAuth) return <Redirect to={routes.profile} />;

  return (
    <Layout
      footer={
        <footer className="l-footer">
          <ButtonWithLoading onClick={handleSignIn} isDisabled={!canSignIn}>
            {t('confirmationLabel')}
          </ButtonWithLoading>
        </footer>
      }
    >
      <div className="l-row">
        <div className="c-title">{t('header')}</div>
      </div>
      <div className="l-row l-row--mt-16">
        <div className="c-text">{t('text')}</div>
      </div>
      <div className="l-row l-row--mt-16">
        <PhoneInput
          maxLength={phoneNumberMaxLength}
          onChange={setPhoneNumber}
          value={phoneNumber}
        />
      </div>
      <div className="l-row l-row--mt-16">
        <Link to={signUpStartRoute}>
          <button className="c-link">{t('buttonLabel')}</button>
        </Link>
      </div>
    </Layout>
  );
};
